import React, { useState } from 'react';
import { IconPlus, IconWifi } from './PlanIcons';
import './FaqSection.css';

const WHATSAPP_URL = 'https://api.whatsapp.com/send?phone=5521987940668&text=Vim%20do%20site%20da%20Faynet%20e%20quero%20saber%20mais%20sobre%20os%20planos!&app_absent=0';

const FAQ_ITEMS = [
  {
    question: 'Minha internet caiu, o que eu faço?',
    answer:
      'Primeiro, verifique as luzes do roteador e tente reiniciá-lo, desligando da tomada por 30 segundos. Se o problema continuar, fale com a gente pelo WhatsApp ou pela Central do Assinante que nossa equipe já vai te ajudar.',
  },
  {
    question: 'Como faço para acessar a central do assinante?',
    answer:
      'Basta acessar com o CPF do titular (sem pontos e traços) e a senha, que tem de 1 a 6 dígitos.',
  },
  {
    question: 'Quais são as formas de pagamento?',
    answer:
      'A mensalidade é pré-paga, com cobrança pro rata, enviada por e-mail e WhatsApp. A taxa de instalação e adesão pode ser paga via Pix, boleto ou cartão direto pela Central do Assinante, que também está disponível como aplicativo para Android.',
  },
  {
    question: 'Existe fidelidade nos planos?',
    answer:
      'Sim, todos os planos avulsos e pacotes completos têm fidelidade de 12 meses. A taxa de instalação é de R$ 120,00 para qualquer plano contratado.',
  },
  {
    question: 'A Faynet atende a minha região?',
    answer:
      'Confira nossa área de cobertura na página "Cobertura" ou fale com a nossa equipe pelo WhatsApp informando seu endereço para confirmarmos a disponibilidade.',
  },
  {
    question: 'Posso trocar de plano depois de contratar?',
    answer:
      'Sim! É só entrar em contato com a nossa equipe pelo WhatsApp ou pela Central do Assinante para solicitar a alteração do seu plano quando quiser.',
  },
];

function FaqSection() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex((current) => (current === index ? null : index));
  };

  return (
    <section className="faq" id="faq">
      <div className="faq__wrapper">
        <div className="faq__main">
          <span className="faq__badge">Dúvidas frequentes</span>
          <h2 className="faq__title">
            O melhor <span className="faq__title--highlight">serviço</span> para você
          </h2>

          <div className="faq__list">
            {FAQ_ITEMS.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div className={`faq-item ${isOpen ? 'faq-item--open' : ''}`} key={item.question}>
                  <button
                    type="button"
                    className="faq-item__question"
                    onClick={() => toggle(index)}
                    aria-expanded={isOpen}
                  >
                    {item.question}
                    <span className="faq-item__icon">
                      <IconPlus width={18} height={18} />
                    </span>
                  </button>
                  <div className="faq-item__answer">
                    <p>{item.answer}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <aside
          className="faq-cta"
          style={{
            backgroundImage:
              "linear-gradient(135deg, rgba(44, 10, 74, 0.88) 0%, rgba(75, 25, 121, 0.85) 55%, rgba(58, 18, 100, 0.9) 100%), url('/index/banner2-planos.png')",
          }}
        >
          <span className="faq-cta__icon">
            <IconWifi width={26} height={26} />
          </span>
          <h3 className="faq-cta__title">Já tem internet?</h3>
          <p className="faq-cta__text">
            Faça sua portabilidade para a Faynet e ganhe <strong>instalação grátis</strong> + roteador incluso.
          </p>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="faq-cta__btn"
          >
            <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" width="18" height="18">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
            </svg>
            Fale com um consultor
          </a>
        </aside>
      </div>
    </section>
  );
}

export default FaqSection;
